import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { useHistory } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import CardContext from "../../context/card/CardContext";
import EmployeeContext from "../../context/employee/EmployeeContext";
import Preloader from "./../layout/Preloader";
import ActionMenu from "../layout/ActionMenu";
import useForm from "../../hooks/useForm";
import useTokenCheck from "../../hooks/useTokenCheck";
import NumberFormat from "react-number-format";
import usePageTitle from "../../hooks/usePageTitle";

const CardAllocation = (props) => {
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const configContext = useContext(ConfigContext);
  const cardContext = useContext(CardContext);
  const employeeContext = useContext(EmployeeContext);

  const { getConfigValueByCode, getConfigValueByNameSponser } = configContext;
  const { setAlert, clearAlerts } = alertContext;
  const { token } = authContext;
  const { isLoading, loadSponsorContracts } = cardContext;
  const { clearCurrentEmployee } = employeeContext;
  const history = useHistory();

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Card Allocation",
  });

  const [card, setCard] = useState({
    cardNumber: "",
  });
  const { hasTokenExpired } = useTokenCheck();
  const { cardNumber } = card;
  const cardNumberRef = useRef(null);
  const onChange = (val) => {
    setCard({ ...card, cardNumber: val });
  };
  const onSubmit = async (e) => {
    await hasTokenExpired();
    e.preventDefault();
    if (cardNumber === "") {
      clearAlerts();
      // clearErrors();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 468);
      setAlert(msg, "danger");
    } else {
      clearAlerts();
      try {
        const res = await loadSponsorContracts(
          { cardnumber: cardNumber },
          token
        );
        console.log("Response: ", res);
        if (res && res.msgCode) {
          const msg = getConfigValueByCode(
            "generalConfig",
            "RESPONSE_MSG",
            res.msgCode
          );
          setAlert(msg, res.status === "ERROR" ? "danger" : "info");
        } else {
          console.log("Redirecting to Employee link: ");
          clearCurrentEmployee();
          // history.push("/employee-detail", { prevPath: "/emp_mgmt" });
          history.replace("/employee-detail");
        }
      } catch (err) {
        console.log("Error::::", JSON.stringify(err));
        let errMsg = getConfigValueByCode("generalConfig", "RESPONSE_MSG", 475);
        setAlert(errMsg, "danger");
      }
    }
  };

  const cancelAction = async () => {
    clearAlerts();
    history.goBack();
  };

  const [labels, setLabels] = useState({
    cardSerialNumber: "",
  });
  useEffect(() => {
    let cardSerialNumber = getConfigValueByNameSponser(
      "generalConfig",
      "Label",
      "label.cardSerialNumber"
    );
    setLabels({
      ...labels,
      cardSerialNumber,
    });
    //eslint-disable-next-line
  }, []);

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
  } = useForm({
    inputList: {
      cardNumber: cardNumberRef,
    },
    screenName: "card_allocation",
  });

  useEffect(() => {
    const isValid = validateAllFields();
    setIsFormValid(isValid);
    console.log("Form is valid", isValid);
    //eslint-disable-next-line
  }, [card]);
  return (
    <Fragment>
      <Popup />
      {isLoading && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronHome"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <div className="privateView__pageTitle">
          <h1>CARD ALLOCATION</h1>
          <div className="privateView__pageTitle__note">
            {/* <span className="required">*</span>denotes a required field */}
          </div>
        </div>

        <div className="privateView__formBody">
          <Form noValidate>
            <Form.Group as={Row}>
              <Col xs lg="4">
                <Form.Label htmlFor="cardNumber">
                  {labels.cardSerialNumber}
                  <span className="required" aria-label="Input required">
                    (*Required)
                  </span>
                  :{" "}
                </Form.Label>
              </Col>
              <Col xs lg="4">
                <NumberFormat
                  aria-required="true"
                  className="mb-4"
                  id="cardNumber"
                  name="cardNumber"
                  onValueChange={(values) => onChange(values.floatValue)}
                  value={cardNumber}
                  onBlur={(e) => validateField(e, labels.cardSerialNumber)}
                  getInputRef={cardNumberRef}
                />
              </Col>
              <Col>
                <Form.Control.Feedback as={Col} type="invalid">
                  {/* {errors.firstName} */}
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Row xs="auto">
              <Col>
                <Button onClick={cancelAction} aria-label="back">
                  BACK
                </Button>
              </Col>
              <Col>
                <Button
                  type="submit"
                  onClick={onSubmit}
                  disabled={!isFormValid}
                >
                  CONTINUE
                </Button>
              </Col>
            </Row>
          </Form>
          {/* <form>
            <div className="privateView__formGroup">
              <label htmlFor="cardNumber">
                Card Number<span className="required">*</span>:{" "}
              </label>
              <input
                type="text"
                name="cardNumber"
                className="form-control"
                onChange={onChange}
                value={cardNumber}
              />
              <div></div>
            </div>
            <div className="privateView__formGroup">
              <input
                type="submit"
                value="CONTINUE"
                className="btn btn-block btn-primary privateView__button"
                onClick={onSubmit}
              />
              <div></div>
              <div></div>
            </div>
          </form> */}
        </div>
      </div>
    </Fragment>
  );
};

export default CardAllocation;
